// API
export const UPLOAD_PIC = 'v1/upload/index'
export const GET_URL_PIC = 'v1/upload/geturl'
